<template>
  <section>
    <PageName title="Пользователи"/>

    <div class="header__page">
      <div class="row gap-20 ai-fs">
        <VInput
          v-model="search"
          @enter="searchUsers"
          icon="search"
          width="469px"
          placeholder="Поиск по пользователям"
        />

        <VSwitch v-model="isTrashed" label="Показать удалённые" @valueChange="getTrashedItems" class="mt-5" />
      </div>

      <div class="right">
        <div class="buttons" style="position: relative;">
          <Button
            v-for="(button, i) in buttons"
            v-show="!button.hide"
            :key="'head' + i"
            :text="button.text"
            :icon="button.icon"
            width="100%"
            :iconWidth="button.iconWidth || '15px'"
            class="buttons__item"
            @click="button.event"
            :style="button.style"
          />
        </div>
        <transition name="fade">
          <div
            ref="clearTicketsForm" 
            @focusout="focusout"
          >
              <Form 
                v-show="clearTicketsDialog" 
                v-model="clearTicketsValue"
                class="clear-tickets__form"
                @request="clearTickets"
              >
                <div class="row clear-tickets__inputs">
                  <VInput
                    name="date_from"
                    type="date"
                    placeholder="ДД.ММ.ГГГГ"
                    required
                  />
                  <VInput
                    name="date_to"
                    type="date"
                    placeholder="ДД.ММ.ГГГГ"
                    required
                    right
                  />
                </div>
                <div class="row">
                  <Button
                    :loading="clearTicketsloading"
                    width="100%"
                    height="48px"
                    text="Очистить"
                    class="btn-primary"

                  />
                  <Button
                    @click.native.prevent="resetClearTickets()"
                    width="100%"
                    height="48px"
                    text="Отменить"
                    class="btn-secondary"
                  />
                </div>
              </Form>
          </div>
        </transition>
      </div>
    </div>

    <Preloader v-if="usersLoading" />

    <VTable
        v-show="!usersLoading"
        itemsType="array"
        :columns="usersColumns"
        :items="mapedUsers"
        :sortApi="sortUsers"
        :selectedIndices="selectedIndices"
        @select="select"
        @row-click="openUser"
        selectable
        isUser
        ref="table"
    />
    <PagePagination
        v-if="pagination.lastPage > 1"
        :pageList="pagination.pageList"
        :currentPage="pagination.currentPage"
        @get-page="getPage"
    />
  </section>
</template>

<script>
import moment from "moment";
import PagePagination from "@/components/PagePagination";
import VTable from "@/components/Table/VTable";
import PageName from "@/components/PageName";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import { clearTickets } from "@/api/users";
// import { phone } from "@/utils/filters/formatFilters";
import { mapState, mapActions } from "vuex";
import Preloader from "@/components/Preloader";
import Button from "@/components/Button.vue";
import Form from "@/components/Form/Form.vue";
import VSwitch from "@/components/VSwitch.vue";
import { mixinAdminPanelUsers } from "@/mixins/users/mixinAdminPanelUsers";

export default {
  name: "Users",
  components: {
    VSwitch,
    PagePagination,
    PageName,
    VTable,
    VInput,
    Preloader,
    Button,
    Form
  },
  mixins: [mixinAdminPanelUsers],
  data() {
    return {
      usersColumns: [
        { title: "№", sort: true, value: "id" },
        { title: "Cоздан", sort: true, value: "created_at" },
        { title: "Изменен", sort: true, value: "updated_at" },
        { title: "Фамилия", sort: true, value: "surname" },
        { title: "Имя", sort: true, value: "name" },
        { title: "Отчество", sort: true, value: "patronymic" },
        { title: "Email", sort: true, value: "email" },
        { title: "Логин", sort: true, value: "login" },
        { title: "Подразделение", sort: true, value: "departments.name" },
        { title: "Номер служебного телефона", sort: true, value: "phone" },
        { title: "VIP", sort: false, value: "is_vip" }
      ],
      buttons: [
          {
            text: "Очистить билеты",
            icon: "tickets-clear",
            event: this.toggleClearTickets,
          },
          {
            text: "Восстановить",
            icon: "user_restore",
            event: this.restore || this.callback,
          },
          {
            text: "Создать",
            icon: "addFile",
            event: this.create || this.callback,
          },
          {
            text: "Удалить",
            icon: "delete",
            event: this.delete || this.callback,
            iconWidth: "12px",
          },
      ],
      clearTicketsDialog: false,
      clearTicketsloading: false,
      clearTicketsValue: {},

      urlSave: '/admin-panel/save/users',
      urlProfile: '/admin-panel/profile/users/'
    }
  },

  computed: {
    ...mapState("users", [
      "users",
      "usersLoading",
    ]),

  },
  methods: {
    ...mapActions("users", ["getUsers"]),

    toggleClearTickets() {
      this.clearTicketsDialog = !this.clearTicketsDialog
    },
    async clearTickets(data) {
      this.clearTicketsloading = true
      let params = {
        'date_from': moment(data.date_from, "DD.MM.YYYY").format("YYYY/MM/DD"),
        'date_to': moment(data.date_to, "DD.MM.YYYY").format("YYYY/MM/DD")
      }
      try {
        await clearTickets(params).finally(() => {
          this.clearTicketsloading = false
          this.$root.alert("Билеты за период успешно удалены")
          this.clearTicketsDialog = false
          this.clearTicketsValue.date_from = ''
          this.clearTicketsValue.date_to = ''
        })
      } catch (err) {
        Promise.reject(err)
      }
    },
    resetClearTickets () {
      this.clearTicketsDialog = false
      this.clearTicketsValue.date_from = ''
      this.clearTicketsValue.date_to = ''
    },
    focusout(event) {
      const enteringParent = this.$refs.clearTicketsForm.contains(event.relatedTarget);
      if (!enteringParent) {
        this.clearTicketsDialog = false
      }
    },

    getUsersByParams (params) {
      this.$store.dispatch('users/getUsersListPage', params)
    }
  }
}
</script>

<style scoped lang="scss">
  .row {
    display: flex;
    justify-content: space-between;
  }

  .date-input {
    width: calc(50% - 6px) !important;
  }

  .clear-tickets {
    &__form {
      justify-content: space-between;
      position: absolute;
      display: block;
      background: #FFFFFF;
      border: 1px solid rgba(0, 65, 102, 0.2);
      box-shadow: 0px 4px 4px rgba(0, 32, 51, 0.04), 0px 8px 24px rgba(0, 32, 51, 0.12);
      border-radius: 4px;
      width: 400px;
      z-index: 2;
      padding: 16px;
    }

    &__inputs {
      margin-bottom: 20px;
    }
  }

  .btn-secondary {
    margin-left: 12px;
  }
</style>
